const minWidth = 768;
const isMobile = window.innerWidth <= minWidth;

export default {
  user: {
    authenticate: false
  },
  area: null,
  loading: false,
  menu: [],
  menu_enlarged: isMobile,
  profile: null
};
